// alterado - revisado

const tipoEsporteHobbyRiscoList = [
    {
        id: 10,
        descricao: 'Nenhum',
        ordem: 10,
    },
    {
        id: 20,
        descricao: 'Acquaride',
        ordem: 20,
    },
    {
        id: 30,
        descricao: 'Alpinismo',
        ordem: 30,
    },
    {
        id: 40,
        descricao: 'Arvorismo',
        ordem: 40,
    },
    {
        id: 50,
        descricao: 'Asa-delta',
        ordem: 50,
    },
    {
        id: 60,
        descricao: 'Balonismo',
        ordem: 60,
    },
    {
        id: 70,
        descricao: 'Base Jumping',
        ordem: 70,
    },
    {
        id: 80,
        descricao: 'Big Wave Surfing',
        ordem: 80,
    },
    {
        id: 90,
        descricao: 'BMX',
        ordem: 90,
    },
    {
        id: 100,
        descricao: 'Boulder',
        ordem: 100,
    },
    {
        id: 110,
        descricao: 'Cave Diving',
        ordem: 110,
    },
    {
        id: 120,
        descricao: 'Cheerleader',
        ordem: 120,
    },
    {
        id: 130,
        descricao: 'Escalada',
        ordem: 130,
    },
    {
        id: 140,
        descricao: 'Free Style Motocross (FMX)',
        ordem: 140,
    },
    {
        id: 150,
        descricao: 'Heli-Skiing',
        ordem: 150,
    },
    {
        id: 160,
        descricao: 'Hipismo',
        ordem: 160,
    },
    {
        id: 170,
        descricao: 'Kitesurf',
        ordem: 170,
    },
    {
        id: 180,
        descricao: 'Mergulho com Cilindro',
        ordem: 180,
    },
    {
        id: 190,
        descricao: 'Mergulho em Caverna',
        ordem: 190,
    },
    {
        id: 200,
        descricao: 'Montaria em Touro',
        ordem: 200,
    },
    {
        id: 210,
        descricao: 'Motocross',
        ordem: 210,
    },
    {
        id: 220,
        descricao: 'Mountain Bike',
        ordem: 220,
    },
    {
        id: 230,
        descricao: 'Parapente',
        ordem: 230,
    },
    {
        id: 240,
        descricao: 'Paraquedismo',
        ordem: 240,
    },
    {
        id: 250,
        descricao: 'Parkour',
        ordem: 250,
    },
    {
        id: 260,
        descricao: 'Rafting',
        ordem: 260,
    },
    {
        id: 270,
        descricao: 'Rapel',
        ordem: 270,
    },
    {
        id: 280,
        descricao: 'Rope Jumping',
        ordem: 280,
    },
    {
        id: 290,
        descricao: 'Salto de Penhasco',
        ordem: 290,
    },
    {
        id: 300,
        descricao: 'Skeleton',
        ordem: 300,
    },
    {
        id: 310,
        descricao: 'Sky Surfing',
        ordem: 310,
    },
    {
        id: 320,
        descricao: 'Slackline Highline',
        ordem: 320,
    },
    {
        id: 330,
        descricao: 'Street Luge',
        ordem: 330,
    },
    {
        id: 340,
        descricao: 'Surf',
        ordem: 340,
    },
    {
        id: 350,
        descricao: 'Voo Livre',
        ordem: 350,
    },
    {
        id: 360,
        descricao: 'Windsurf',
        ordem: 360,
    },
    {
        id: 370,
        descricao: 'Wingsuit',
        ordem: 370,
    },
    {
        id: 380,
        descricao: 'Wing Walking',
        ordem: 380,
    },
    {
        id: 900, // HARDCODE.idTipoEsporteHobbyRiscoOutros
        descricao: 'Outros',
        ordem: 900,
    },
]

export default tipoEsporteHobbyRiscoList